var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header" }, [
    _vm.designVersion === 2
      ? _c(
          "div",
          { staticClass: "v2" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("heading", { attrs: { level: "h1" } }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _vm.subtitle
              ? _c("paragraph", {
                  staticClass: "subtitle center",
                  class: { hidden: _vm.isSubmitting },
                  attrs: { type: "p", variation: "medium" },
                  domProps: { innerHTML: _vm._s(_vm.subtitle) },
                })
              : _vm._e(),
          ],
          1
        )
      : _c("div", { staticClass: "v1" }, [
          _c("div", { staticClass: "logo-container" }, [
            _c("div", { staticClass: "logo", style: _vm.logo }),
          ]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.cardIndex >= 0
            ? _c(
                "svg",
                {
                  staticClass: "number-slider",
                  attrs: { width: "182", height: "50" },
                },
                [
                  _c("line", {
                    attrs: { x1: "15", y1: "20", x2: "160", y2: "20" },
                  }),
                  _vm._v(" "),
                  _vm._l(4, function (index) {
                    return _c("circle", {
                      key: index,
                      class: { selected: _vm.cardIndex == index },
                      attrs: { cx: 15 + 50 * (index - 1), cy: "20", r: "15" },
                    })
                  }),
                  _vm._v(" "),
                  _vm._l(4, function (index) {
                    return _c(
                      "text",
                      {
                        key: index,
                        attrs: { x: 10 + 50 * (index - 1), y: "26" },
                      },
                      [_vm._v(_vm._s(index))]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-icons-wrapper" }, [
      _c("img", {
        staticClass: "header-icons",
        attrs: {
          src: "/assets/images/fitness-icon-hero.svg",
          alt: "fitness-icon-hero",
        },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "header-icons",
        attrs: {
          src: "/assets/images/autobahn-icon-small.svg",
          alt: "autobahn-icon-small",
        },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "header-icons",
        attrs: {
          src: "/assets/images/plus-icon-hero.svg",
          alt: "plus-icon-hero",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }